import React from 'react';
import { ActionGroup, Button, Form, FormGroup, TextInput, FormSelect, FormSelectOption, Grid, GridItem,
  TextArea,
  FileUpload,
  Panel, PanelMain, PanelMainBody, PanelHeader, Divider, PanelFooter,
  HelperText,
  HelperTextItem,
  Checkbox,
  List,
  ListItem,
  Alert
} from '@patternfly/react-core';
import { Table /* data-codemods */, Thead, Tr, Th, Tbody, Td, Caption} from '@patternfly/react-table';
import { AppContext } from "shared/context/AppContext";

const THEORY_CSV_EXAMPLE = `wersja arkusza;z1;z2;z3;z4;z5;z6;z7;z8;z9;z10;z11;z12;z13;z14;z15;z16;z17;z18;z19;z20;z21;z22;z23;z24;z25;z26;z27;z28;z29;z30;z31;z32;z33;z34;z35;z36;z37;z38;z39;z40
INF.03-KG-26.06-001;1;1;0;0;1;1;1;1;1;1;1;1;1;1;0;0;0;0;1;1;1;1;0;1;0;0;1;1;0;1;1;1;1;0;1;0;1;0;0;0
INF.03-KG-26.06-001;0;0;0;0;0;1;1;1;1;0;1;0;0;1;0;0;0;0;1;0;0;0;0;0;0;0;1;1;0;0;0;0;0;1;1;0;0;0;0;0
INF.03-KG-26.06-006;1;1;1;0;0;0;0;0;1;1;1;1;1;1;0;1;0;0;0;1;0;1;1;1;0;0;1;1;1;0;1;0;0;1;1;1;0;0;1;1`;

const PRACTICE_CSV_EXAMPLE = `nr zadania;rezultat 1;rezultat 2;rezultat 3;rezultat 4;rezultat 5
INF.03-02-26.06-SG;16;22;12;20;17
INF.03-02-26.06-SG;4;22;5;18;6
INF.03-02-26.06-SG;16;22;15;16;20
INF.03-02-26.06-SG;20;25;15;20;14`;

const csvPreviewStyle = {
  overflowX: "auto",
  maxWidth: "100%",
  maxHeight: "320px",
  marginTop: "0.75rem",
  padding: "1rem",
  border:
    "1px solid var(--pf-t--global--border--color--default)",
  borderRadius:
    "var(--pf-t--global--border--radius--small)",
  backgroundColor:
    "var(--pf-t--global--background--color--secondary--default)",
  color:
    "var(--pf-t--global--text--color--regular)",
  fontFamily:
    "'Cascadia Code', 'Fira Code', Consolas, monospace",
  fontSize: "0.8rem",
  lineHeight: 1.65,
  whiteSpace: "pre",
};

const CsvExample = ({
  title,
  description,
  content,
}) => (
  <details style={{ marginTop: "1rem" }}>
    <summary
      style={{
        cursor: "pointer",
        fontWeight: 600,
      }}
    >
      {title}
    </summary>

    <Alert
      variant="info"
      isInline
      title="Przykładowa zawartość pliku CSV"
      style={{ marginTop: "0.75rem" }}
    >
      {description && (
        <p style={{ marginBottom: "0.75rem" }}>
          {description}
        </p>
      )}

      <pre style={csvPreviewStyle}>
        <code>{content}</code>
      </pre>
    </Alert>
  </details>
);

const PRACTICE_DESCRIPTION_OPTIONS = {
  "INF.03": {
    rezultat1: "operacje na bazie danych",
    rezultat2: "zawartość witryny internetowej",
    rezultat3: "działanie witryny internetowej",
    rezultat4: "styl CSS witryny internetowej",
    rezultat5:
      "skrypt w języku PHP lub skrypt w języku JavaScript",
  },

  "INF.02": {
    rezultat1:
      "wykonane okablowanie sieciowe oraz połączenie fizyczne urządzeń",
    rezultat2: "diagnostyka",
    rezultat3:
      "skonfigurowane urządzenia sieciowe",
    rezultat4: "skonfigurowany serwer",
    rezultat5: "skonfigurowana stacja robocza",
    rezultat6:
      "wskazania dla użytkownika komputera",
    przebieg1:
      "przebieg wykonania okablowania sieciowego",
  },
};
const normalizeTaskName = (value = "") =>
  value
    .toLowerCase()
    .replace(/\s+/g, "");

const getCookie = (name) => {
  const cookies = document.cookie
    ? document.cookie.split(";")
    : [];

  for (const cookie of cookies) {
    const trimmedCookie = cookie.trim();

    if (trimmedCookie.startsWith(`${name}=`)) {
      return decodeURIComponent(
        trimmedCookie.substring(name.length + 1),
      );
    }
  }

  return null;
};

const slugifyFileName = (value = "") =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ł/g, "l")
    .replace(/Ł/g, "L")
    .replace(/[^a-zA-Z0-9.-]+/g, "-")
    .replace(/^-+|-+$/g, "");

class FormGrid  extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      theory_maximum_per_task: 1,
      selectedQualificationSymbol: "",
      formIsValid: false,
      time: new Date().toLocaleDateString(),
      oke: "",
      province: "",
      city: "",
      organization_symbol: "",
      branch_name: "",
      title: "ANALIZA EGZAMINU ZAWODOWEGO W ROKU SZKOLNYM",
      option: "",
      isPrepareExamAnalysis: false,
      isGeneratingReport: false,
      reportStatus: null,
      reportMessage: "",
      isTheoryUpload: false,
      isPracticeUpload: false,
      isUploadTheoryError: false,
      isUploadPracticeError: false,
      
      exam_data: [],
      post_data: {},
      fields: {
        chat_gpt_theory_prompt: "",
        chat_gpt_practice_prompt: "",
        theory_table: {},
        practice_table: {},
        theory_data: {},
        practice_data: {},
        school_year: "",
        theory_scope: "",
        theory_number_of_tasks: "",
        theory_maximum_per_tasks: {},
        theory_description_tasks: {},
        practice_scope: "",
        practice_number_of_tasks: "",
        practice_column_names: [],
        practice_maximum_per_tasks: {},
        practice_description_tasks: {},
      },
      errors: {
        theory: "",
        practice: ""
      },
      validated: {},
      selectedTheoryFile: "",
      selectedPracticeFile: "",
      document_data: false
    };
    if(this.state.app_stage === 'dev') this.state.api_url = `${this.state.django_url}:${this.state.django_expose_port}`
    if(this.state.app_stage === 'prod') this.state.api_url = this.state.django_url
    
    this.handleUpload = async (selectedFile, stage) => {
      const apiUrl = (
        this.context?.state?.react_app_api_url || ""
      ).replace(/\/+$/, "");

      if (!apiUrl) {
        console.error("Nie udało się ustalić adresu API.");

        if (stage === "theory") {
          this.setState((previousState) => ({
            isUploadTheoryError: true,
            errors: {
              ...previousState.errors,
              theory: "Nie udało się ustalić adresu API.",
            },
          }));
        } else if (stage === "practice") {
          this.setState((previousState) => ({
            isUploadPracticeError: true,
            errors: {
              ...previousState.errors,
              practice: "Nie udało się ustalić adresu API.",
            },
          }));
        }

        return;
      }

      const formData = new FormData();

      formData.append("File", selectedFile);
      formData.append("Stage", stage);

      try {
        const csrfToken = getCookie("csrftoken");
        const response = await fetch(
          `${apiUrl}/ti/api/v1/upload`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "X-CSRFToken": csrfToken,
            },
            body: formData,
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const result = await response.json();

        console.log("Upload response:", result);

        if (stage === "theory") {
          this.setState((previousState) => {
            const theoryMaximumPerTasks = {};
            const theoryDescriptionTasks = {};

            result.state.data.theory.sheets?.forEach(
              (sheet) => {
                theoryMaximumPerTasks[sheet.sheet_name] = {
                  max_per_task:
                    previousState.theory_maximum_per_task,
                };

                theoryDescriptionTasks[sheet.sheet_name] = {
                  description_task: "",
                };
              },
            );

            return {
              isTheoryUpload: true,
              isUploadTheoryError: false,
              fields: {
                ...previousState.fields,
                theory_scope:
                  result.state.data.theory.scope,
                theory_number_of_tasks:
                  result.state.data.theory.number_of_tasks,
                theory_table:
                  result.state.data.theory.table,
                theory_data:
                  result.state.data.theory,
                theory_maximum_per_tasks:
                  theoryMaximumPerTasks,
                theory_description_tasks:
                  theoryDescriptionTasks,
              },
            };
          });
        } else if (stage === "practice") {
          this.setState((previousState) => ({
            isPracticeUpload: true,
            isUploadPracticeError: false,
            fields: {
              ...previousState.fields,
              practice_scope:
                result.state.data.practice.scope,
              practice_number_of_tasks:
                result.state.data.practice.number_of_tasks,
              practice_column_names:
                result.state.data.practice.column_names,
              practice_table:
                result.state.data.practice.table,
              practice_data:
                result.state.data.practice,
            },
          }));
        }
      } catch (error) {
        console.error("Upload error:", error);

        if (stage === "theory") {
          this.setState((previousState) => ({
            isUploadTheoryError: true,
            errors: {
              ...previousState.errors,
              theory: "Nie przesłano danych. Błąd!",
            },
          }));
        } else if (stage === "practice") {
          this.setState((previousState) => ({
            isUploadPracticeError: true,
            errors: {
              ...previousState.errors,
              practice: "Nie przesłano danych. Błąd!",
            },
          }));
        }
      }
    };

    this.onFileChangeTheory = (event) => {
      this.setState({ selectedTheoryFile: event.target.files[0]});
      this.setState({ theory_results_file_name: event.target.files[0].name});
      this.handleUpload(event.target.files[0], "theory");
    };
    
    this.onFileChangePractice = (event) => {
      this.setState({ selectedPracticeFile: event.target.files[0]});
      this.setState({ practice_results_file_name: event.target.files[0].name});
      this.handleUpload(event.target.files[0], "practice");
    };

    this.handleClearTheory = () => {
      this.setState({ isTheoryUpload: false, isUploadTheoryError: false, selectedTheoryFile: "", theory_results_file_name: ""});
      this.setState({fields: {
        ...this.state.fields,
        theory_scope: "",
        theory_number_of_tasks: "",
      }});
    };

    this.handleClearPractice = () => {
      this.setState({ 
        isPracticeUpload: false,
        isUploadPracticeError: false,
        selectedPracticeFile: "",
        practice_results_file_name: "",
      });
      this.setState({fields: {
        ...this.state.fields,
        practice_scope: "",
        practice_number_of_tasks: "",
      }});
    };

    this.handleOptionChange = (_event, value) => {
      const selectedQualification =
        this.props.analysis_state.analysis_data.examanalysis
          .active_qualifications_for_branch
          .find(
            (qualification) =>
              String(qualification.qualification_id) ===
              String(value),
          );

      this.setState({
        option: value,
        selectedQualificationSymbol:
          selectedQualification?.qualification_symbol || "",
      });
    };

  }
  validatePracticePointsSums = () => {
    const errors = {};

    const sheets =
      this.state.fields.practice_data.sheets || [];

    sheets.forEach((sheet) => {
      const sheetName = sheet.sheet_name;

      const tasks =
        this.state.fields
          .practice_maximum_per_tasks[
            sheetName
          ] || {};

      const values = Object.values(tasks)
        .filter(
          (value) =>
            value !== "" &&
            value !== null &&
            value !== undefined,
        )
        .map(Number);

      const sum = values.reduce(
        (total, value) => total + value,
        0,
      );

      if (values.length === 0) {
        errors[`practice-${sheetName}`] =
          `Arkusz ${sheetName}: suma punktów wynosi ${sum}, a musi wynosić 100.`;
      } else if (
        values.some(
          (value) =>
            !Number.isFinite(value) ||
            value <= 0 ||
            value > 100,
        )
      ) {
        errors[`practice-${sheetName}`] =
          "Każda punktacja musi być liczbą z zakresu 1–100.";
      } else if (sum !== 100) {
        errors[`practice-${sheetName}`] =
          `Suma punktów wynosi egzaminu praktycznego ${sum}, a musi wynosić 100.`;
      }
    });

    return errors;
  };
  PrepareExamAnalysis = async (args, jsonData) => {
    const apiUrl = (
      this.context?.state?.react_app_api_url || ""
    ).replace(/\/+$/, "");

    if (!apiUrl) {
      this.setState({
        error: new Error(
          "Nie udało się ustalić adresu API.",
        ),
        isPrepareExamAnalysis: false,
        isGeneratingReport: false,
        reportStatus: "danger",
        reportMessage:
          "Nie udało się ustalić adresu API.",
      });

      return;
    }

    try {
      const csrfResponse = await fetch(
        `${apiUrl}/ti/api/get-csrf-token/`,
        {
          method: "GET",
          credentials: "include",
        },
      );

      if (!csrfResponse.ok) {
        throw new Error(
          `Nie udało się pobrać CSRF: HTTP ${csrfResponse.status}`,
        );
      }

      const csrfData = await csrfResponse.json();

      // Jeżeli endpoint zwraca token w JSON:
      const csrfToken =
        csrfData.csrfToken ||
        getCookie("csrftoken");

      if (!csrfToken) {
        throw new Error("Brak tokenu CSRF.");
      }

      const response = await fetch(
        `${apiUrl}/ti/api/v1/${args}`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          body: JSON.stringify(jsonData),
        },
      );

      if (!response.ok) {
        const responseText = await response.text();

        console.error(
          "PrepareExamAnalysis response:",
          response.status,
          responseText,
        );

        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      const backendErrors =
        data?.props?.errors ||
        data?.props?.error ||
        {};

      if (
        backendErrors &&
        Object.keys(backendErrors).length > 0
      ) {
        console.error(
          "Backend report errors:",
          backendErrors,
        );

        throw new Error(
          Object.values(backendErrors).join(", "),
        );
      }

      console.log(
        "PrepareExamAnalysis RESPONSE DATA:",
        data,
      );

      const generatedFileName =
        data?.post?.output_pdf_file_name ||
        "raport PDF";

      this.setState({
        exam_data: data,

        chat_gpt_theory_prompt:
          data?.analysis_results?.conclusions
            ?.chat_gpt_theory_prompt || "",

        chat_gpt_practice_prompt:
          data?.analysis_results?.conclusions
            ?.chat_gpt_practice_prompt || "",

        isPrepareExamAnalysis: true,
        reportStatus: "success",
        reportMessage:
          `Raport został wygenerowany: ${generatedFileName}`,
      });
    } catch (error) {
      console.error(
        "PrepareExamAnalysis error:",
        error,
      );

      this.setState({
        error,
        isPrepareExamAnalysis: false,
        reportStatus: "danger",
        reportMessage:
          error?.message ||
          "Nie udało się wygenerować raportu.",
      });
    } finally {
      this.setState({
        isGeneratingReport: false,
      });
    }};


  updateState = (field, value) => {
    this.setState({field: value},() => {console.log(this.state)})
  }

  handleChange = (field, value) => {
    let fields = this.state.fields;
    fields[field] = value;
    this.setState({ fields });
    //console.log(fields);
  }

  handleChangeTheoryTask = (_event, field, value) => {
    const numericValue =
      value === "" ? "" : parseInt(value, 10);

    this.setState((previousState) => {
      const theoryMaximumPerTasks = {
        ...previousState.fields.theory_maximum_per_tasks,
      };

      const theoryDescriptionTasks = {
        ...previousState.fields.theory_description_tasks,
      };

      previousState.fields.theory_data.sheets?.forEach(
        (sheet) => {
          theoryMaximumPerTasks[sheet.sheet_name] = {
            ...theoryMaximumPerTasks[sheet.sheet_name],
            max_per_task: numericValue,
          };

          theoryDescriptionTasks[sheet.sheet_name] = {
            ...theoryDescriptionTasks[sheet.sheet_name],
            description_task: "",
          };
        },
      );

      return {
        theory_maximum_per_task: numericValue,
        fields: {
          ...previousState.fields,
          theory_maximum_per_tasks:
            theoryMaximumPerTasks,
          theory_description_tasks:
            theoryDescriptionTasks,
        },
      };
    });
  };

  handleChangePracticeTask = (
    event,
    value,
  ) => {
    const sheetName = event.currentTarget.name;
    const fieldName = event.currentTarget.id;

    this.setState((previousState) => {
      const sheetTasks = {
        ...previousState.fields
          .practice_maximum_per_tasks[
            sheetName
          ],
      };

      if (value === "") {
        delete sheetTasks[fieldName];
      } else {
        sheetTasks[fieldName] = Number(value);
      }

      return {
        fields: {
          ...previousState.fields,
          practice_maximum_per_tasks: {
            ...previousState.fields
              .practice_maximum_per_tasks,
            [sheetName]: sheetTasks,
          },
        },
      };
    });
  };
  handleChangeTaskDesc = (_event, sheet_name, field, value) => {
    let fields = this.state.fields;
    // fields[field] = value;
    fields["practice_description_tasks"][sheet_name] = {
      ...fields["practice_description_tasks"][sheet_name],
      [_event]: value,
    }
    this.setState({ fields });
    console.log(fields);
  }

  handleValidationUploadFile = (validated, errors, field, stage, message) => {
    validated[field] = "default" //!!!!!!!! must be
    if(stage === "theory") {
      this.setState({isUploadTheoryError: false});
      if (!this.state.isTheoryUpload) {
        this.setState({formIsValid: false});
        validated[field] = "error"
        errors[field] = message;
        this.setState({isUploadTheoryError: true});
      }
    }
    if(stage === "practice") {
      this.setState({isUploadPracticeError: false});
      if (!this.state.isPracticeUpload) {
        this.setState({formIsValid: false});
        validated[field] = "error"
        errors[field] = message;
        this.setState({isUploadPracticeError: true});
      }
    }
    console.log(field, validated[field]);
  }
  
  ValidateInputFormReg = (fields, validated, errors, field, regex, error_message) => {
    validated[field] = "default" //!!!!!!!! must be
    if (!fields[field]) {
      this.setState({formIsValid: false});
      //this.updateState({formIsValid: false})
      validated[field] = "error"
      errors[field] = error_message;
    }
    if (typeof fields[field] !== "undefined") {
      if (!String(fields[field]).match(regex)) {
        this.setState({formIsValid: false});
        //this.updateState({formIsValid: false})
        validated[field] = "error"
        errors[field] = error_message;
      }
    }
    //console.log(field, validated[field]);
  }
  
  ValidateInputTasks = (
    fields,
    errors,
    sheetName,
  ) => {
    const tasks =
      fields.practice_maximum_per_tasks[
        sheetName
      ] || {};

    const values = Object.values(tasks)
      .filter(
        (value) =>
          value !== "" &&
          value !== null &&
          value !== undefined,
      )
      .map(Number);

    if (values.length === 0) {
      errors[`practice-${sheetName}`] =
        `Arkusz ${sheetName}: podaj punktację przynajmniej jednego rezultatu lub przebiegu.`;

      return;
    }

    const hasInvalidValue = values.some(
      (value) =>
        !Number.isFinite(value) ||
        value <= 0 ||
        value > 100,
    );

    if (hasInvalidValue) {
      errors[`practice-${sheetName}`] =
        "Każda podana punktacja musi być liczbą z zakresu 1–100.";

      return;
    }

    const sum = values.reduce(
      (total, value) => total + value,
      0,
    );

    if (sum !== 100) {
      errors[`practice-${sheetName}`] =
        `Suma punktów egzaminu praktycznego wynosi ${sum}, a musi wynosić 100.`;
    }
  };
  ValidateInputForm = (fields, validated, errors, field, error_message) => {
    validated[field] = "default" //!!!!!!!! must be
    if (typeof fields[field] !== "undefined") {
      if (parseFloat(fields[field]) < 0 || parseFloat(fields[field]) > 100) {
        this.setState({formIsValid: false});
        //this.updateState({formIsValid: false})
        validated[field] = "error"
        errors[field] = error_message;
      }
    }
    //console.log(field, validated[field]);
  }

  handleValidation = (event) => {
    const fields = {
      ...this.state.fields,
    };

    const validated = {
      ...this.state.validated,
    };

    const errors = {};
    //this.updateState(this.state.formIsValid,  true)

    fields.school_year = event.target.school_year.value
    fields.theory_number_of_tasks = event.target.theory_number_of_tasks.value
    fields.theory_scope = event.target.theory_scope.value;
    
    fields.practice_scope = event.target.practice_scope.value;
    fields.practice_number_of_tasks = event.target.practice_number_of_tasks.value
    
    this.ValidateInputFormReg(fields, validated, errors, "school_year", /^[0-9]{4}\/[0-9]{4}$/, `np. ${new Date().getFullYear()-1}/${new Date().getFullYear()}`);
    this.ValidateInputFormReg(fields, validated, errors, "theory_scope", /^[0-9]+,[0-9]+:[0-9]+,[0-9]+$/, "np. 1,38:2,42");
    this.ValidateInputFormReg(fields, validated, errors, "theory_number_of_tasks", /^[0-9]+$/, "np. 40");
    
    this.ValidateInputFormReg(fields, validated, errors, "practice_scope", /^[0-9]+,[0-9]+:[0-9]+,[0-9]+$/, "np. 1,38:3,9");
    this.ValidateInputFormReg(fields, validated, errors, "practice_number_of_tasks", /^[0-9]+$/, "np. 6");
    
    if (
      Array.isArray(fields.practice_data.sheets)
    ) {
      fields.practice_data.sheets.forEach((sheet) => {
        this.ValidateInputTasks(
          fields,
          errors,
          sheet.sheet_name,
        );
      });
    }

    this.handleValidationUploadFile(validated, errors, "theory_input_data", "theory", "Prześlij dane do analizy")
    this.handleValidationUploadFile(validated, errors, "practice_input_data", "practice", "Prześlij dane do analizy")

    this.ValidateInputForm(fields, validated, errors, "theory_oke", "Liczba z zakresu [0-100]");
    this.ValidateInputForm(fields, validated, errors, "theory_province", "Liczba z zakresu [0-100]");
    this.ValidateInputForm(fields, validated, errors, "theory_country", "Liczba z zakresu [0-100]");
    this.ValidateInputForm(fields, validated, errors, "practice_oke", "Liczba z zakresu [0-100]");
    this.ValidateInputForm(fields, validated, errors, "practice_province", "Liczba z zakresu [0-100]");
    this.ValidateInputForm(fields, validated, errors, "practice_country", "Liczba z zakresu [0-100]");
    this.ValidateInputForm(fields, validated, errors, "received_diploma_oke", "Liczba z zakresu [0-100]");
    this.ValidateInputForm(fields, validated, errors, "received_diploma_province", "Liczba z zakresu [0-100]");
    this.ValidateInputForm(fields, validated, errors, "received_diploma_country", "Liczba z zakresu [0-100]");

    // this.setState({ errors: errors });
    // console.log(`From is valid: ${this.state.formIsValid}`)
    // return this.state.formIsValid;
    const formIsValid =
      Object.keys(errors).length === 0 &&
      this.state.isTheoryUpload &&
      this.state.isPracticeUpload;

    this.setState({
      formIsValid,
      errors,
      validated: { ...validated },
    });

    console.log("Form is valid:", formIsValid);
    console.log("Validation errors:", errors);

    return {
      formIsValid,
      errors,
    };
  }
  
  HandleSubmit = async (event) => {
    event.preventDefault();

    const {
      formIsValid,
      errors,
    } = this.handleValidation(event);

    if (!formIsValid) {
      const errorMessages = [
        ...new Set(
          Object.values(errors)
            .filter(Boolean),
        ),
      ];

      this.setState({
        isGeneratingReport: false,
        isPrepareExamAnalysis: false,
        reportStatus: "danger",
        reportMessage:
          errorMessages.length > 0
            ? errorMessages.join(" • ")
            : "Uzupełnij wymagane dane formularza.",
      });

      return;
    }

    console.log("HandleSubmit ok");

    this.setState({
      isGeneratingReport: true,
      isPrepareExamAnalysis: false,
      reportStatus: null,
      reportMessage: "",
    });
    // dalsze budowanie json_data...
      const theory_scope_rows = event.target.theory_scope.value.trim().split(':')[0];
      const theory_start_row = parseInt(theory_scope_rows.split(',')[0]);
      const theory_end_row = parseInt(theory_scope_rows.split(',')[1]);

      const theory_scope_cols = event.target.theory_scope.value.trim().split(':')[1];
      const theory_start_column = parseInt(theory_scope_cols.split(',')[0]);
      const theory_end_column = parseInt(theory_scope_cols.split(',')[1]);
      
      const practice_scope_rows = event.target.practice_scope.value.trim().split(':')[0];
      const practice_start_row = parseInt(practice_scope_rows.split(',')[0]);
      const practice_end_row = parseInt(practice_scope_rows.split(',')[1]);

      const practice_scope_cols = event.target.practice_scope.value.trim().split(':')[1];
      const practice_start_column = parseInt(practice_scope_cols.split(',')[0]);
      const practice_end_column = parseInt(practice_scope_cols.split(',')[1]);

      const branchName =
        event.target.branch_name.value.trim();

      const qualificationSymbol =
        event.target.qualification.options[
          event.target.qualification.selectedIndex
        ].text;

      const schoolYear =
        event.target.school_year.value.replace("/", "-");

      const outputFileBase = [
        "Analiza",
        slugifyFileName(branchName),
        slugifyFileName(qualificationSymbol),
        slugifyFileName(schoolYear),
      ].join("-");

      const practiceDescriptionTasks = {};

      this.state.fields.practice_data.sheets?.forEach(
        (sheet) => {
          practiceDescriptionTasks[sheet.sheet_name] = {};

          Object.entries(
            this.state.fields.practice_data.column_names,
          ).forEach(([_key, _column], index) => {
            const taskNumber = index + 1;

            const pointsField =
              `${sheet.sheet_name}-max_per_task${taskNumber}`;

            const descriptionField =
              `${sheet.sheet_name}-description_task${taskNumber}`;

            const points =
              this.state.fields
                .practice_maximum_per_tasks[
                  sheet.sheet_name
                ]?.[pointsField];

            const description =
              this.state.fields
                .practice_description_tasks[
                  sheet.sheet_name
                ]?.[descriptionField] ?? "";

            const hasPoints =
              points !== "" &&
              points !== null &&
              points !== undefined;

            /*
            * Rezultat/przebieg jest aktywny, jeśli ma
            * podaną punktację. Opis pozostaje opcjonalny.
            */
            if (hasPoints) {
              practiceDescriptionTasks[
                sheet.sheet_name
              ][descriptionField] = (
                description.trim()
              );
            }
          });
        },
      );

      const json_data = {
        state: this.props.analysis_state.analysis_data.examanalysis,
        oke: event.target.oke_city.value,
        province: event.target.province.value,
        city: event.target.city.value,
        organization_symbol: event.target.organization_symbol.value,
        // branch_name: event.target.branch_name.value,
        branch_name: branchName,
        qualification_id: parseInt(event.target.qualification.value),
        qualification_symbol: event.target.qualification.options[event.target.qualification.selectedIndex].text,
        school_year: event.target.school_year.value,
        title: this.state.title,
        author: event.target.author.value,
        document_data: event.target.document_data.checked,
        theory_results_file_name: this.state.theory_results_file_name,
        practice_results_file_name: this.state.practice_results_file_name,
        output_pdf_file_name:
          `${outputFileBase}.pdf`,

        output_tex_file_name:
          `${outputFileBase}.tex`,
        theory: {
          scope: {
              start_row: theory_start_row, //było 0
              end_row: theory_end_row,
              start_column: theory_start_column,
              end_column: theory_end_column,
              number_of_tasks: parseInt(event.target.theory_number_of_tasks.value)
          },
          maximum_per_task: parseInt(event.target.theory_maximum_per_task.value),
          maximum_per_task_multi: this.state.fields.theory_maximum_per_tasks,
          description_task: this.state.fields.theory_description_tasks,
          oke: parseFloat(event.target.theory_oke.value),
          province: parseFloat(event.target.theory_province.value),
          country: parseFloat(event.target.theory_country.value),
          conclusions: event.target.theory_conclusions.value
        },
        practice: {
          scope: {
            start_row: practice_start_row,
            end_row: practice_end_row,
            start_column: practice_start_column,
            end_column: practice_end_column,
            number_of_tasks: parseInt(event.target.practice_number_of_tasks.value)
          },
          maximum_per_task_multi: this.state.fields.practice_maximum_per_tasks,
          description_task: practiceDescriptionTasks,
          oke: parseFloat(event.target.practice_oke.value),
          province: parseFloat(event.target.practice_province.value),
          country: parseFloat(event.target.practice_country.value),
          conclusions: event.target.practice_conclusions.value
        },
        received_diploma: {
          oke: parseFloat(event.target.received_diploma_oke.value),
          province: parseFloat(event.target.received_diploma_province.value),
          country: parseFloat(event.target.received_diploma_country.value)
        },
        conclusions: event.target.conclusions.value
        };

    await this.PrepareExamAnalysis(
      "prepareexamanalysis",
      json_data,
    );
  };

  ShowTable = (table, transposedMatrix) => {
    return (
        <table>
          <thead>
            <tr>
              {Object.keys(table).map((field, index) => {
                return (
                  <React.Fragment key={field+index}>
                    <th style={{padding: "1px", textAlign: "center" }}>{field}</th>
                  </React.Fragment>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {Object.entries(transposedMatrix).map(([key, field],index) => {
              return (
                <React.Fragment key={key+field+index}>
                  <tr>
                    {Object.entries(transposedMatrix[key]).map(([l, value],j) => {
                      return (
                        <td key={l+value+key+j} style={{textAlign: "center" }}>{value}</td>
                      )
                    })}
                  </tr>
                </React.Fragment>
              )
            })}
          </tbody>
        </table>

    )
  }

  render() {
    if (this.props.analysis_state.isLoadedAnalysis === true && Object.keys(this.props.analysis_state.analysis_data.examanalysis).length > 0) {
      if (this.state.isPrepareExamAnalysis) console.log(this.state.exam_data);
      if(this.props.analysis_state.analysis_data.examanalysis.oke_city) this.state.oke = this.props.analysis_state.analysis_data.examanalysis.oke_city;
      if(this.props.analysis_state.analysis_data.examanalysis.province) this.state.province = this.props.analysis_state.analysis_data.examanalysis.province;
      if(this.props.analysis_state.analysis_data.examanalysis.city) this.state.city = this.props.analysis_state.analysis_data.examanalysis.city;
      if(this.props.analysis_state.analysis_data.examanalysis.organization_symbol) this.state.organization_symbol = this.props.analysis_state.analysis_data.examanalysis.organization_symbol;
      if(this.props.analysis_state.analysis_data.examanalysis.organization_branch_name) this.state.branch_name = this.props.analysis_state.analysis_data.examanalysis.organization_branch_name;
      if(this.props.analysis_state.analysis_data.examanalysis.school_year) this.state.school_year = this.props.analysis_state.analysis_data.examanalysis.school_year;
      
      const qualifications_for_branch = this.props.analysis_state.analysis_data.examanalysis.active_qualifications_for_branch;

      const selectedQualification =
        qualifications_for_branch.find(
          (qualification) =>
            String(qualification.qualification_id) ===
            String(this.state.option),
        ) || qualifications_for_branch[0];

      const selectedQualificationSymbol =
        this.state.selectedQualificationSymbol ||
        selectedQualification?.qualification_symbol ||
        "";

      const practiceDescriptionOptions =
        PRACTICE_DESCRIPTION_OPTIONS[
          selectedQualificationSymbol
        ] || {};

      //transpose object
      if( this.state.isTheoryUpload && Object.keys(this.state.fields.theory_table).length > 0 ) {
        let theory_dict = this.state.fields.theory_table
        let keys = Object.keys(theory_dict);
        var theory_transposedMatrix = theory_dict[keys[0]].map(function(col,i){  
          return keys.map(function(_,j){ return theory_dict[keys[j]][i] })
        });
        //console.log(theory_transposedMatrix)
      }
      if( this.state.isPracticeUpload && Object.keys(this.state.fields.practice_table).length > 0 ) {
        let practice_dict = this.state.fields.practice_table
        let keys = Object.keys(practice_dict);
        var practice_transposedMatrix = practice_dict[keys[0]].map(function(col,i){  
          return keys.map(function(_,j){ return practice_dict[keys[j]][i] })
        });
        //console.log(practice_transposedMatrix)
      }
      //console.log(this.state.fields)
      return (
        <Form onSubmit={this.HandleSubmit}>
          <Panel variant="raised">
            <PanelHeader>Informacje</PanelHeader>
            <Divider />
            <PanelMain>
              <PanelMainBody>
              <Grid hasGutter md={6}>
                <GridItem span={3}>
                <FormGroup label="OKE" isRequired fieldId="oke_city">
                  <TextInput
                    isRequired
                    type="text"
                    //placeholder="Poznań"
                    id="oke_city"
                    name="oke_city"
                    aria-describedby="oke-city-helper"
                    value={this.state.oke}
                    onChange={(_event) => this.handleNameChange(_event)}
                  />
                </FormGroup>
                </GridItem>
                <GridItem span={3}>
                    <FormGroup label="Powiat" isRequired fieldId="province">
                    <TextInput
                        isRequired
                        type="text"
                        //placeholder="Pilski"
                        id="province"
                        name="province"
                        value={this.state.province}
                        onChange={(_event) => this.handleProvinceChange(_event)}
                    />
                    </FormGroup>
                </GridItem>
                <GridItem span={3}>
                    <FormGroup label="Miejscowość" isRequired fieldId="city">
                    <TextInput
                        isRequired
                        type="text"
                        id="city"
                        //placeholder="Wyrzysk"
                        name="city"
                        value={this.state.city}
                        onChange={(_event) => this.handleCityChange(_event)}
                    />
                    </FormGroup>
                </GridItem>
                <GridItem span={3}>
                    <FormGroup label="Symbol organizacji" isRequired fieldId="organization_symbol">
                    <TextInput
                        isRequired
                        type="text"
                        //placeholder="CKZiU"
                        id="organization_symbol"
                        name="organization_symbol"
                        value={this.state.organization_symbol}
                        onChange={(_event) => this.handleOrganizationSymbolChange(_event)}
                    />
                    </FormGroup>
                </GridItem>
                <GridItem span={3}>
                    <FormGroup label="Nazwa odziału" isRequired fieldId="branch_name">
                    <TextInput
                        isRequired
                        type="text"
                        //placeholder="Technik informatyk"
                        id="branch_name"
                        name="branch_name"
                        value={this.state.branch_name}
                        onChange={(_event) => this.handleBranchNameChange(_event)}
                    />
                    </FormGroup>
                </GridItem>
                <GridItem span={2}>
                  <FormGroup label="Symbol kwalifikacji" isRequired fieldId="qualification">
                    <FormSelect
                      value={this.state.option}
                      onChange={(_event, value) => this.handleOptionChange(_event, value)}
                      id="qualification"
                      name="qualification"
                      aria-label="qualification"
                    >
                      {qualifications_for_branch.map((option, index) => (
                        <FormSelectOption key={index} value={option.qualification_id} label={option.qualification_symbol} />
                      ))}
                    </FormSelect>
                  </FormGroup>
                </GridItem>
                <GridItem span={2}>
                  <FormGroup label="Rok szkolny" isRequired fieldId="school_year">
                    <TextInput
                        isRequired
                        type="text"
                        id="school_year"
                        name="school_year"
                        value={this.state.school_year}
                        onChange={this.handleChange.bind(this, "school_year")}
                        validated={this.state.validated["school_year"]}
                    />
                  </FormGroup>
                </GridItem>
                <GridItem span={3}>
                  <FormGroup label="Autor" fieldId="author">
                    <TextInput
                        type="text"
                        id="author"
                        name="author"
                        value={this.state.author}
                    />
                  </FormGroup>
                </GridItem>
                <GridItem span={2}>
                  <FormGroup fieldId="document_data" label="Data dokumentu">
                    <Checkbox label={this.state.time} value={this.state.document_data} aria-label="document_data" id="document_data" name="document_data" />
                  </FormGroup>
                </GridItem>
              </Grid>
              </PanelMainBody>
            </PanelMain>
          </Panel>
          <Panel variant="raised">
            <PanelHeader>Wyniki egzaminu teoretycznego</PanelHeader>
            <Divider />
            <PanelMain>
              <PanelMainBody>
                <Grid hasGutter md={6}>
                  <GridItem span={6}>
                    <FormGroup label="Wynik egzaminu teoretycznego w formacie [csv]" fieldId="theory_input_data" isRequired>
                      <FileUpload
                        id="theory_results_file_name"
                        value={this.state.selectedTheoryFile}
                        filename={this.state.theory_results_file_name}
                        filenamePlaceholder="Przeciągnij i upuść plik lub prześlij go"
                        onFileInputChange={this.onFileChangeTheory}
                        onClearClick={this.handleClearTheory}
                        browseButtonText="Prześlij"

                        validated={this.state.validated.theory_input_data}
                        // helperTextInvalid={this.state.errors["theory_input_data"]}
                      />
                      {this.state.isTheoryUpload && (
                        <HelperText>
                          <HelperTextItem variant="success">
                            Przesłano [{parseFloat(this.state.selectedTheoryFile.size/1024).toFixed(2)} KB]
                          </HelperTextItem>
                        </HelperText>
                      )}
                      {this.state.isUploadTheoryError && !this.state.isTheoryUpload && (
                        <HelperText>
                          <HelperTextItem variant="error">
                            {this.state.errors.theory}
                          </HelperTextItem>
                        </HelperText>
                      )}
                    </FormGroup>
                  </GridItem>
                  <GridItem span={2}>
                    <FormGroup label="Zakres komórek" fieldId="theory_scope" isRequired>
                      <TextInput
                          type="text"
                          id="theory_scope"
                          name="theory_scope"
                          value={this.state.fields.theory_scope}
                          onChange={this.handleChange.bind(this, "theory_scope")}
                          isDisabled
                          validated={this.state.validated.theory_scope}
                          // helperTextInvalid={this.state.errors.theory_scope}
                      />
                    </FormGroup>
                  </GridItem>
                  <GridItem span={2}>
                    <FormGroup label="Liczba zadań" fieldId="theory_number_of_tasks" isRequired>
                      <TextInput
                          type="number"
                          id="theory_number_of_tasks"
                          name="theory_number_of_tasks"
                          value={this.state.fields.theory_number_of_tasks}
                          onChange={this.handleChange.bind(this, "theory_number_of_tasks")}
                          isDisabled

                          // helperTextInvalid={this.state.errors.theory_number_of_tasks}
                          validated={this.state.validated.theory_number_of_tasks}
                      />
                    </FormGroup>
                    </GridItem>
                    <GridItem span={2}>
                      <FormGroup
                        label="Punktów za zadanie"
                        fieldId="theory_maximum_per_task"
                        isRequired
                      >
                        <TextInput
                          type="number"
                          id="theory_maximum_per_task"
                          name="theory_maximum_per_task"
                          value={this.state.theory_maximum_per_task}
                          onChange={this.handleChangeTheoryTask.bind(
                            this,
                            "theory_maximum_per_task",
                          )}
                          validated={
                            this.state.validated.theory_maximum_per_task
                          }
                        />
                      </FormGroup>
                  </GridItem>
                </Grid>
              </PanelMainBody>
            </PanelMain>
            <PanelFooter>
              {this.state.isTheoryUpload && Object.keys(this.state.fields.theory_table).length > 0 && (
                <React.Fragment>
                  {this.ShowTable(this.state.fields.theory_table, theory_transposedMatrix)}
                </React.Fragment>
              )}
              <CsvExample
                title="Pokaż przykładowy plik CSV — egzamin teoretyczny"
                description={
                  <>
                    Pierwsza kolumna zawiera wersję arkusza, a kolejne
                    kolumny wyniki poszczególnych zadań.
                  </>
                }
                content={THEORY_CSV_EXAMPLE}
              />
              <Divider />
              <br />
              <List>
                <ListItem><small>Wymagany wiersz nagłówkowy w pliku csv np. <b>[wersja arkusza; z1; z2; z3; ...]</b></small></ListItem>
                <ListItem><small>Pierwsza kolumna musi zawierać wersję arkusza w pliku csv np. <b>INF.02-KG-22.06-003</b></small></ListItem>
                <ListItem><small>Dane w formacie csv muszą zawierać separator <b>[ ; ]</b></small></ListItem>
              </List>
              </PanelFooter>
          </Panel>
          <Panel variant="raised">
            <PanelHeader>Wyniki egzaminu praktycznego</PanelHeader>
            <Divider />
            <PanelMain>
              <PanelMainBody>
                <Grid hasGutter md={6}>
                  <GridItem span={6}>
                    <FormGroup label="Wynik egzaminu praktycznego w formacie [csv]" fieldId="practice_input_data" isRequired>
                      <FileUpload
                          id="practice_results_file_name"
                          value={this.state.selectedPracticeFile}
                          filename={this.state.practice_results_file_name}
                          filenamePlaceholder="Przeciągnij i upuść plik lub prześlij go"
                          onFileInputChange={this.onFileChangePractice}
                          onClearClick={this.handleClearPractice}
                          browseButtonText="Prześlij"
                          
                          // helperTextInvalid={this.state.errors["practice_input_data"]}
                          validated={this.state.validated.practice_input_data}
                        />
                        {this.state.isPracticeUpload && (
                          <HelperText>
                            <HelperTextItem variant="success">
                              Przesłano [{parseFloat(this.state.selectedPracticeFile.size/1024).toFixed(2)} KB]
                            </HelperTextItem>
                          </HelperText>
                        )}
                        {this.state.isUploadPracticeError && !this.state.isPracticeUpload && (
                          <HelperText>
                            <HelperTextItem variant="error">
                              {this.state.errors.practice}
                            </HelperTextItem>
                          </HelperText>
                        )}
                    </FormGroup>
                  </GridItem>
                  <GridItem span={2}>
                    <FormGroup label="Zakres komórek" fieldId="practice_scope" isRequired>
                      <TextInput
                          type="text"
                          id="practice_scope"
                          name="practice_scope"
                          value={this.state.fields.practice_scope}
                          onChange={this.handleChange.bind(this, "practice_scope")}
                          isDisabled
                          
                          // helperTextInvalid={this.state.errors.practice_scope}
                          validated={this.state.validated.practice_scope}
                      />
                    </FormGroup>
                  </GridItem>
                  <GridItem span={2}>
                    <FormGroup label="Liczba zadań" fieldId="practice_number_of_tasks" isRequired>
                      <TextInput
                          type="number"
                          id="practice_number_of_tasks"
                          name="practice_number_of_tasks"
                          value={this.state.fields.practice_number_of_tasks}
                          onChange={this.handleChange.bind(this, "practice_number_of_tasks")}
                          isDisabled
                          // helperTextInvalid={this.state.errors.practice_number_of_tasks}
                          validated={this.state.validated.practice_number_of_tasks}
                      />
                    </FormGroup>
                  </GridItem>
                  <GridItem span={2}></GridItem>
                  {parseInt(this.state.fields.practice_number_of_tasks) > 0 &&
                    <GridItem span={12}>
                      <Table aria-label="Hoverable table" variant="compact" isStriped>
                        <Caption>Maksymalna liczba punktów za zadanie</Caption>
                        <Thead>
                          <Tr>
                            <Th>Arkusz</Th>
                            <Th screenReaderText="Punkty i opis zadania" />
                            {/* <Th>{' '}</Th> */}
                            {Object.entries(this.state.fields.practice_column_names).map(([a, res] ,i) => {
                              return (
                                <Th key={a+i+res}>{res[0].toUpperCase() + res.slice(1)}</Th>
                              )
                            })}
                          </Tr>
                        </Thead>
                        <Tbody>
                          {this.state.fields.practice_data.sheets.map(
                            (sheet, j) => {
                              const sheetPoints =
                                this.state.fields
                                  .practice_maximum_per_tasks[
                                    sheet.sheet_name
                                  ] || {};

                              const pointsSum = Object.values(
                                sheetPoints,
                              )
                                .filter(
                                  (value) =>
                                    value !== "" &&
                                    value !== null &&
                                    value !== undefined,
                                )
                                .reduce(
                                  (sum, value) =>
                                    sum + Number(value),
                                  0,
                                );

                              const sheetError =
                                this.state.errors[
                                  `practice-${sheet.sheet_name}`
                                ];

                              return (
                                <React.Fragment
                                  key={`${sheet.sheet_name}-${j}`}
                                >
                                    <Tr key={j+sheet.sheet_name+j}>
                                  <Td>{sheet.sheet_name}</Td>
                                  <Td>
                                    Punkty<br /><br />
                                    Opis
                                  </Td>
                                  {Object.entries(this.state.fields.practice_data.column_names).map(([a, res] ,i) => {
                                    const k = i + 1;
                                    const taskName = normalizeTaskName(res);
                                    const suggestedDescription =
                                      practiceDescriptionOptions[taskName] || "";
                                    return (
                                      <React.Fragment key={k+res}>
                                        <Td>
                                        <FormGroup fieldId={`${sheet.sheet_name}-max_per_task${k}`}>
                                          <TextInput
                                            type="number"
                                            id={`${sheet.sheet_name}-max_per_task${k}`}
                                            name={sheet.sheet_name}
                                            min={1}
                                            max={100}
                                            value={
                                              this.state.fields
                                                .practice_maximum_per_tasks[
                                                  sheet.sheet_name
                                                ]?.[
                                                  `${sheet.sheet_name}-max_per_task${k}`
                                                ] ?? ""
                                            }
                                            onChange={(event, value) =>
                                              this.handleChangePracticeTask(
                                                event,
                                                value,
                                              )
                                            }
                                            validated={
                                              this.state.validated[
                                                `${sheet.sheet_name}-max_per_task${k}`
                                              ]
                                            }
                                          />
                                        </FormGroup>
                                        <FormGroup
                                          fieldId={`${sheet.sheet_name}-description_task${k}`}
                                        >
                                          <TextInput
                                            type="text"
                                            id={`${sheet.sheet_name}-description_task${k}`}
                                            name={`${sheet.sheet_name}-description_task${k}`}
                                            list={`practice-descriptions-${sheet.sheet_name}-${k}`}
                                            placeholder={
                                              suggestedDescription ||
                                              "Opis opcjonalny"
                                            }
                                            value={
                                              this.state.fields
                                                .practice_description_tasks[
                                                  sheet.sheet_name
                                                ]?.[
                                                  `${sheet.sheet_name}-description_task${k}`
                                                ] ?? ""
                                            }
                                            onChange={this.handleChangeTaskDesc.bind(
                                              this,
                                              `${sheet.sheet_name}-description_task${k}`,
                                              sheet.sheet_name,
                                            )}
                                          />
                                          <datalist
                                            id={`practice-descriptions-${sheet.sheet_name}-${k}`}
                                          >
                                            {Object.values(
                                              practiceDescriptionOptions,
                                            ).map((description) => (
                                              <option
                                                key={description}
                                                value={description}
                                              />
                                            ))}
                                          </datalist>
                                        </FormGroup>
                                        </Td>
                                      </React.Fragment>
                                    )
                                  })}
                              </Tr>

                              <Tr>
                                <Td colSpan={2}>
                                  <strong>Suma punktów</strong>
                                </Td>

                                <Td
                                  colSpan={
                                    Object.keys(
                                      this.state.fields
                                        .practice_data.column_names,
                                    ).length
                                  }
                                >
                                  <strong>
                                    {pointsSum} / 100
                                  </strong>

                                  {sheetError && (
                                    <HelperText>
                                      <HelperTextItem
                                        variant="error"
                                      >
                                        {sheetError}
                                      </HelperTextItem>
                                    </HelperText>
                                  )}
                                </Td>
                              </Tr>
                            </React.Fragment>
                          );
                        },
                      )}
                        </Tbody>
                      </Table>
                    </GridItem>
                  }
                </Grid>
              </PanelMainBody>
            </PanelMain>
            <PanelFooter>
              {this.state.isPracticeUpload && Object.keys(this.state.fields.practice_table).length > 0 && (
                <React.Fragment>
                  {this.ShowTable(this.state.fields.practice_table, practice_transposedMatrix)}
                </React.Fragment>
              )}
              <CsvExample
                title="Pokaż przykładowy plik CSV — egzamin praktyczny"
                description={
                  <>
                    Pierwsza kolumna zawiera wersję arkusza, a kolejne
                    kolumny punkty uzyskane za rezultaty lub przebiegi.
                  </>
                }
                content={PRACTICE_CSV_EXAMPLE}
              />
              <Divider />
              <br />
              <List>
                <ListItem><small>Wymagany wiersz nagłówkowy w pliku csv np. <b>[nr zadania, rezultat 1; rezultat 2; rezultat 3; ...]</b></small></ListItem>
                <ListItem><small>Pierwsza kolumna musi zawierać wersję arkusza w pliku csv np. <b>EE.09-01-22.06-SG</b></small></ListItem>
                <ListItem><small>Dane w formacie csv muszą zawierać separator <b>[ ; ]</b></small></ListItem>
              </List>
            </PanelFooter>
          </Panel>
          <Panel variant="raised">
            <PanelHeader>Wyniki procentowe OKE, powiat, kraj</PanelHeader>
            <Divider />
            <PanelMain>
              <PanelMainBody>
                <Grid hasGutter md={6}>
                  <GridItem span={8}>
                    <Table aria-label="Hoverable table" variant="compact">
                      <Thead>
                        <Tr>
                          <Th screenReaderText="Punkty i opis zadania" />
                          {/* <Th></Th> */}
                          <Th>Teoria</Th>
                          <Th>Praktyka</Th>
                          <Th>Dyplom</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr>
                          <Td><b>Powiat {this.state.province}</b></Td>
                          <Td>
                            <FormGroup label="" fieldId="theory_province">
                              <TextInput
                                  type="number"
                                  id="theory_province"
                                  name="theory_province"
                                  value={this.state.theory_province}
                                  onChange={this.handleChange.bind(this, "theory_province")}
                                  
                                  // helperTextInvalid={this.state.errors["theory_province"]}
                                  validated={this.state.validated.theory_province}
                              />
                            </FormGroup>
                          </Td>
                          <Td>
                            <FormGroup label="" fieldId="practice_province">
                              <TextInput
                                  type="number"
                                  id="practice_province"
                                  name="practice_province"
                                  value={this.state.practice_province}
                                  onChange={this.handleChange.bind(this, "practice_province")}
                                  
                                  // helperTextInvalid={this.state.errors["practice_province"]}
                                  validated={this.state.validated.practice_province}
                              />
                            </FormGroup>
                          </Td>
                          <Td>
                            <FormGroup label="" fieldId="received_diploma_province">
                              <TextInput
                                  type="number"
                                  id="received_diploma_province"
                                  name="received_diploma_province"
                                  value={this.state.received_diploma_province}
                                  onChange={this.handleChange.bind(this, "received_diploma_province")}
                                  
                                  // helperTextInvalid={this.state.errors["received_diploma_province"]}
                                  validated={this.state.validated.received_diploma_province}
                              />
                            </FormGroup>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td><b>OKE {this.state.oke}</b></Td>
                          <Td>
                            <FormGroup label="" fieldId="theory_oke">
                              <TextInput
                                  type="number"
                                  id="theory_oke"
                                  name="theory_oke"
                                  value={this.state.theory_oke}
                                  onChange={this.handleChange.bind(this, "theory_oke")}
                                  
                                  // helperTextInvalid={this.state.errors["theory_oke"]}
                                  validated={this.state.validated.theory_oke}
                              />
                            </FormGroup>
                          </Td>
                          <Td>
                            <FormGroup label="" fieldId="practice_oke">
                              <TextInput
                                  type="number"
                                  id="practice_oke"
                                  name="practice_oke"
                                  value={this.state.practice_oke}
                                  onChange={this.handleChange.bind(this, "practice_oke")}

                                  validated={this.state.validated.practice_oke}
                                  // helperTextInvalid={this.state.errors["practice_oke"]}
                              />
                            </FormGroup>
                          </Td>
                          <Td>
                            <FormGroup label="" fieldId="received_diploma_oke">
                              <TextInput
                                  type="number"
                                  id="received_diploma_oke"
                                  name="received_diploma_oke"
                                  value={this.state.received_diploma_oke}
                                  onChange={this.handleChange.bind(this, "received_diploma_oke")}

                                  validated={this.state.validated.received_diploma_oke}
                                  // helperTextInvalid={this.state.errors["received_diploma_oke"]}
                              />
                            </FormGroup>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td><b>Kraj</b></Td>
                          <Td>
                            <FormGroup label="" fieldId="theory_country">
                              <TextInput
                                  type="number"
                                  id="theory_country"
                                  name="theory_country"
                                  value={this.state.theory_country}
                                  onChange={this.handleChange.bind(this, "theory_country")}

                                  validated={this.state.validated.theory_country}
                                  // helperTextInvalid={this.state.errors["theory_country"]}
                              />
                            </FormGroup>
                          </Td>
                          <Td>
                            <FormGroup label="" fieldId="practice_country">
                              <TextInput
                                  type="number"
                                  id="practice_country"
                                  name="practice_country"
                                  value={this.state.practice_country}
                                  onChange={this.handleChange.bind(this, "practice_country")}

                                  validated={this.state.validated.practice_country}
                                  // helperTextInvalid={this.state.errors["practice_country"]}
                              />
                            </FormGroup>
                          </Td>
                          <Td>
                            <FormGroup label="" fieldId="received_diploma_country">
                              <TextInput
                                  type="number"
                                  id="received_diploma_country"
                                  name="received_diploma_country"
                                  value={this.state.received_diploma_country}
                                  onChange={this.handleChange.bind(this, "received_diploma_country")}
                                  
                                  // helperTextInvalid={this.state.errors["received_diploma_country"]}
                                  validated={this.state.validated.received_diploma_country}
                              />
                            </FormGroup>
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </GridItem>
                </Grid>
              </PanelMainBody>
            </PanelMain>
          </Panel>
          <Panel variant="raised">
            <PanelHeader>Podsumowanie</PanelHeader>
            <Divider />
            <PanelMain>
              <PanelMainBody>
                <Grid hasGutter md={6}>
                  <GridItem span={12}>
                      <FormGroup label="Teoria Chat GPT Prompt (Wklej poniższy prompt do chatgpt.com)" fieldId="chat_gpt_theory_prompt">
                        <TextArea
                          value={this.state.chat_gpt_theory_prompt}
                          id="chat_gpt_theory_prompt"
                          name="chat_gpt_theory_prompt"
                        />
                      </FormGroup>
                  </GridItem>
                  <GridItem span={12}>
                      <FormGroup label="Praktyka Chat GPT Prompt (Wklej poniższy prompt do chatgpt.com)" fieldId="chat_gpt_practice_prompt">
                        <TextArea
                          value={this.state.chat_gpt_practice_prompt}
                          id="chat_gpt_practice_prompt"
                          name="chat_gpt_practice_prompt"
                        />
                      </FormGroup>
                  </GridItem>
                  <GridItem span={12}>
                      <FormGroup label="Wnioski etapu teoretycznego (Aby uzyskać wnioski, wklej wynik prompta z chatgpt.com)" fieldId="theory_conclusions">
                        <TextArea
                          value={this.state.theory_conclusions}
                          // onChange={(_event) => this.handleConclusionsChange(_event)}
                          id="theory_conclusions"
                          name="theory_conclusions"
                        />
                      </FormGroup>
                  </GridItem>
                  <GridItem span={12}>
                      <FormGroup label="Wnioski etapu praktycznego (Aby uzyskać wnioski, wklej wynik prompta z chatgpt.com)" fieldId="practice_conclusions">
                        <TextArea
                          value={this.state.practice_conclusions}
                          id="practice_conclusions"
                          name="practice_conclusions"
                        />
                      </FormGroup>
                  </GridItem>
                  <GridItem span={12}>
                      <FormGroup label="Wnioski i rekomendacje (Własne wnioski, z pominięciem wniosków z chatgpt.com)" fieldId="conclusions">
                        <TextArea
                          value={this.state.conclusions}
                          // onChange={(_event) => this.handleConclusionsChange(_event)}
                          id="conclusions"
                          name="conclusions"
                        />
                      </FormGroup>
                      {/* <ActionGroup>
                        <Button type="submit" variant="primary">Przygotuj analizę</Button>
                      </ActionGroup> */}
                      <ActionGroup>
                        <Button
                          type="submit"
                          variant="primary"
                          isLoading={
                            this.state.isGeneratingReport
                          }
                          isDisabled={
                            this.state.isGeneratingReport
                          }
                          spinnerAriaValueText="Generowanie raportu"
                        >
                          {this.state.isGeneratingReport
                            ? "Generowanie raportu..."
                            : "Przygotuj analizę"}
                        </Button>
                      </ActionGroup>
                      {this.state.reportStatus && (
                        <Alert
                          variant={this.state.reportStatus}
                          isInline
                          title={
                            this.state.reportStatus === "success"
                              ? "Raport został wygenerowany"
                              : "Błąd generowania raportu"
                          }
                          style={{
                            marginTop: "1rem",
                          }}
                        >
                          {this.state.reportMessage}
                        </Alert>
                      )}
                  </GridItem>
                </Grid>
              </PanelMainBody>
            </PanelMain>
          </Panel>
        </Form>
      )
    }
  }
}
export default FormGrid;